// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__XkJAt","colMaxWidth":"Table_colMaxWidth__15bqL"};